import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {LocalStorage} from "../services/local-storage";
import {SessionService} from "../services/session.service";
import {AuthResponse} from "../models/auth-response";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private _ls: LocalStorage, private session: SessionService) {
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // * Translate to empty obj if nothing

        try {
            if (this.session.isLoggedIn()) {
                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${this.session.getAuthToken()}`
                    }
                });
            }
        } catch (error) {
            console.log("@TokenInterceptor: ", error);
        }
        // * Intercpet response to store the new token on LocalStorage
        return next.handle(req).pipe(
            tap((res: HttpResponse<any>) => {
                if (
                  res instanceof HttpResponse &&
                  !res.url.includes("web-login-start") &&
                  !res.url.includes("resetPassword") &&
                  !res.url.includes("forgotPassword")
                ) {
                  const newToken = res.headers.get("Set-Authorization");
                  const newAuthObject = {} as AuthResponse;

                  // * Add access_token to new auth
                  newAuthObject.access_token = newToken;

                  // * Add expire_in with date now, note: Date.now() returns timestamp
                  // TODO: Duhet pare ca pret EPostaAPI
                  newAuthObject.expires_in = Date.now();

                  this._ls.set("auth", JSON.stringify(newAuthObject));
                }
            })
        );
    }
}
